const defaultLightLogoPath = "/Content/Logos/dashLogoTLP.png";
const defaultDarkLogoPath = "/Content/Logos/darkDashLogoTLP.png";

const getDarkLogoPath = (name: string) => `/Content/Logos/darkDashLogo${name}.png`;
const getLightLogoPath = (name: string) => `/Content/Logos/dashLogo${name}.png`;

const imageCache = new Map<string, Promise<boolean>>();
const logoPathCache = new Map<string, string>();

export function getCachedLogoPath(name: string) {
	if (name === "none") return "";
	return logoPathCache.get(name);
}

function getCandidateLogoPaths(name: string, type: "dark" | "light", noDefault: boolean) {
	const brandPaths = [getDarkLogoPath(name), getLightLogoPath(name)];
	const defaultPaths = [defaultDarkLogoPath, defaultLightLogoPath];
	if (type !== "dark") {
		brandPaths.reverse();
		defaultPaths.reverse();
	}
	return noDefault ? brandPaths : [...brandPaths, ...defaultPaths];
}

/**
 * Attempts to fetch the specified 'dark' or 'light' variant of the logo.
 * If missing, fallbacks to the opposite variant, then to default logos.
 */
export async function getLogoPath(name: string, type: "dark" | "light" = "dark", noDefault = false) {
	if (name === "none") return "";

	const cached = logoPathCache.get(name);
	if (cached !== undefined) return cached;

	for (const path of getCandidateLogoPaths(name, type, noDefault)) {
		if (await checkImage(path)) {
			logoPathCache.set(name, path);
			return path;
		}
	}

	return "";
}

async function fetchIsImage(url: string) {
	const res = await fetch(url);
	const blob = await res.blob();
	return blob.type.startsWith("image/");
}

/**
 * Resolves to whether the url serves an image. Every check of a url shares one request, including checks made
 * while that request is pending or stalled; only a failed request is evicted so the next check retries it.
 */
export function checkImage(url: string) {
	let check = imageCache.get(url);
	if (!check) {
		check = fetchIsImage(url).catch((error: unknown) => {
			imageCache.delete(url);
			throw error;
		});
		imageCache.set(url, check);
	}
	return check;
}
